import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=066e9c5d&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=066e9c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e9c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066e9c5d')) {
      api.createRecord('066e9c5d', component.options)
    } else {
      api.reload('066e9c5d', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=066e9c5d&scoped=true&", function () {
      api.rerender('066e9c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nbEpH5WIhSRY/JS/comp/SearchFilterTokens.vue"
export default component.exports